module.exports = __webpack_public_path__ + "static/img/lefty.5cd40b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/lefty.png
// module id = +axv
// module chunks = 37